/**
 * Standalone trigger for the RecentlyAddedRegistryItemUpdateDrawer.
 *
 * Kept free of Catalog-barrel imports so non-Catalog modules (e.g. the
 * ShippingAddressAndCurrencyDialogsProvider) can open the drawer without
 * creating a circular import through the Catalog index.
 */
import type { RegistryItemFragment } from '@graphql/fragments/registry.graphql.generated';
type OpenRecentlyAddedDrawer = (item?: RegistryItemFragment) => void;

let globalOpenDrawerImmediately: OpenRecentlyAddedDrawer | null = null;

export const setOpenRecentlyAddedDrawer = (open: OpenRecentlyAddedDrawer | null) => {
  globalOpenDrawerImmediately = open;
};

/**
 * Called with no item for an add that has not run yet — the drawer opens in its
 * loading state and the `createRegistryItemSubject` emission fills it in. Called
 * with an item when the add already completed, which skips the loading state.
 */
export const triggerDrawerOpen: OpenRecentlyAddedDrawer = item => {
  globalOpenDrawerImmediately?.(item);
};
